import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=503b0244&scoped=true&"
import script from "./Skin.vue?vue&type=script&lang=js&"
export * from "./Skin.vue?vue&type=script&lang=js&"
import style0 from "./Skin.vue?vue&type=style&index=0&id=503b0244&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b0244",
  null
  
)

export default component.exports